<template>
  <v-container>
    <v-btn
      outlined
      rounded
      color="#173c93"
      :to="getBackRoute()"
    >
      Voltar
    </v-btn>

    <read-article :article="foundCompliance" />
  </v-container>
</template>

<script>
import { externalBySlug } from "../../services/compliance-service";

export default {
  name: "ReadComplianceExternal",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previousRoute = from;
    });
  },
  data() {
    return {
      foundCompliance: {},
      previousRoute: { fullPath: "" },
    };
  },
  async created() {
    this.foundCompliance = await externalBySlug(this.$route.params.slug);
  },
  methods: {
    getBackRoute() {
      if (this.previousRoute.fullPath.includes('compliance')) {
        return this.previousRoute.fullPath;
      } else {
        return '/external/compliance'
      }
    }
  }
};
</script>
